import { POST } from "../utils/request";
// 查询面试结果
export var PostAiInterviewResult = function (orderTokens) { return POST({ url: "/standard/b/aiInterview/result", data: { orderTokens: orderTokens } }); };
// 刷新ai评分
export var PostAiInterviewRefresh = function (orderID) { return POST({ url: "/standard/b/aiInterview/aiScore/refresh/single", data: { orderID: orderID } }); };
// 更新评价
export var PostAiInterviewEvaluation = function (data) {
    return POST({ url: "/standard/b/aiInterview/aiEvaluation/modify", data: data });
};
// 更新职场能力回答
export var PostAiInterviewWorkplace = function (data) {
    return POST({ url: "/standard/b/aiInterview/workplace/answer/modify", data: data });
};
export var SwitchReportModel = function (data) { return POST({ url: "standard/b/reports/switch-model", data: data }); };
export var GetReportVersion = function (orderToken) { return POST({ url: "standard/b/aiInterview/getVersion", data: { orderToken: orderToken } }); };
